import { useTranslation } from 'react-i18next'
import styles from '../../../assets/styles/components/common/ExpandableSideBar.module.scss'

const SideBarLegalLinks = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.legalLinksContainer}>
      <div className={styles.policyWrapper}>
        <a
          href='https://operation36.golf/legal/'
          className={styles.linkText}
          target='_blank'
        >
          {t('common.legal.privacyPolicy')}
        </a>
        <span className={styles.textDivider}>-</span>
        <a
          href='https://operation36.golf/legal/'
          className={styles.linkText}
          target='_blank'
        >
          {t('common.legal.termsOfUse')}
        </a>
      </div>
      <p className={styles.rights}>{t('common.legal.allRightsReserved')}</p>
      <p className={styles.version}>v3.0.0</p>
    </div>
  )
}

export default SideBarLegalLinks
